console.log('product-caja.js caja');

document.getElementById('bundle-form').addEventListener('submit', function (e) {
  e.preventDefault();

  const form = e.target;
  const items = [
    // Productos fijos con IDs reales
    { 
      id: 46495768183004,
      quantity: 1,
      properties: {
        'Caja': 'Core Steps Gift Box'
      }
    }, // Caja
    { 
      id: 44052653965532,
      quantity: 1,
      properties: {
        'Caja': 'Core Steps Gift Box'
      }
    }, // Jabón Atómico Mini
    { 
      id: 44062985421020, 
      quantity: 1 ,
      properties: {
        'Caja': 'Core Steps Gift Box'
      }
    }, // Protector Solar

    // Selecciones del cliente
    { 
      id: form.serum.value, 
      quantity: 1 ,
      properties: {
        'Caja': 'Core Steps Gift Box'
      }
    },
    { 
      id: form.aceite.value, 
      quantity: 1 ,
      properties: {
        'Caja': 'Core Steps Gift Box'
      }
    },
    { 
      id: form.herramienta.value, 
      quantity: 1 ,
      properties: {
        'Caja': 'Core Steps Gift Box'
      }
    }
  ];

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  })
    .then(res => res.json())
    .then(data => {
      window.location.href = '/cart'; 
      console.log('Productos agregados al carrito:', data);
    })
    .catch(err => {
      console.error('Error al agregar al carrito:', err);
    });
});


function updateTotalPrice() {
  let total = 980;

  // Selecciona todos los selects relevantes
  document.querySelectorAll('.bundle-form__select').forEach(select => {
    const selected = select.options[select.selectedIndex];
    const price = parseFloat(selected.dataset.price);
    if (!isNaN(price)) {
      total += price;
    }
  });

  // Mostrar el total con dos decimales
  document.getElementById('total-price').textContent = total.toFixed(2);
}

// Ejecutar al cambiar cualquier selección
document.querySelectorAll('.bundle-form__select').forEach(select => {
  select.addEventListener('change', updateTotalPrice);
});

// Ejecutar al cargar por primera vez
updateTotalPrice();